import React, { useState, useEffect } from 'react'
import { Link, useParams, Redirect } from 'react-router-dom'
import Layout from '../../components/Layout'
import config from '../../config'
import { getNativeAds, createNativeAd } from '../../api/nativeads'
import Button from '../../components/ui/Button'
import { create } from 'sortablejs'
import Moment from 'react-moment'

const NativeAds = () => {
    let { id: siteId } = useParams()
    const [site, setSite] = useState({})
    const [ads, setAds] = useState({})
    const [pendingAds, setPendingAds] = useState({})
    const [isLoading, setLoading] = useState(true)
    const [isLoadingPending, setLoadingPending] = useState(true)
    const [newAdId, setNewAdId] = useState(null)

    /**
     * Load initial data
     */
    useEffect(() => {
        getSite(siteId)
        if (site.native_ad_location_id !== undefined) {
            fetchAds({
                location_id: site.native_ad_location_id,
                status: 'active',
            })
            fetchAdsPending({
                location_id: site.native_ad_location_id,
                status: 'pending',
            })
        }
    }, [site])

    /**
     * Fetch ads by location
     */
    const fetchAds = async (query) => {
        try {
            const ads = await getNativeAds(query)
            setLoading(false)
            setAds(ads)
        } catch (err) {
            alert(
                'Error, something went wrong. Please refresh and try again. Error #vna-0'
            )
        }
    }

    /**
     * Fetch pending ads by location
     */
    const fetchAdsPending = async (query) => {
        try {
            const ads = await getNativeAds(query)
            console.log(ads)
            setLoadingPending(false)
            setPendingAds(ads)
        } catch (err) {
            alert(
                'Error, something went wrong. Please refresh and try again. Error #vna-0'
            )
        }
    }

    /**
     * Sets site object state based off url param (id)
     */
    const getSite = (siteId) => {
        config.sites.find((site) => {
            if (site.value === siteId) {
                setSite(site)
            }
        })
    }

    const newMobileAd = async () => {
        try {
            /**
             * Create new ad with defaults, then redirect user to new ad
             */
            const location_id = site.native_ad_location_id
            const newAd = await createNativeAd({
                location_id: location_id,
                title: 'New Native Ad',
            })

            setNewAdId(newAd.data.id)
        } catch (err) {
            console.log(err)
            alert(err)
        }
    }

    if (newAdId) {
        return <Redirect to={`/dashboard/${siteId}/nativeads/${newAdId}`} />
    }

    return (
        <Layout>
            <div>
                <div className="mb-2 flex justify-between">
                    <div className="text-3xl font-semibold">Mobile Ads</div>
                    <div>
                        <Button onClick={() => newMobileAd()} type="primary">
                            New Mobile Ad
                        </Button>
                    </div>
                </div>
                {isLoading && <div>Loading Mobile Ads...</div>}
                {!isLoading && (
                    <>
                        <div>
                            <div className="text-2xl font-thin">Active Ads</div>
                        </div>
                        <div className="bg-white rounded shadow flex flex-col overflow-hidden">
                            {ads.data &&
                                ads.data.map((ad, index) => (
                                    <Link
                                        className={`p-4 hover:bg-blue-500 flex justify-between items-center hover:text-white`}
                                        to={`/dashboard/${site.value}/nativeads/${ad.id}`}
                                    >
                                        <div>
                                            {ad.title}{' '}
                                            <span
                                                className={`ml-2 text-xs text-white uppercase rounded-full px-2 py-1 bg-green-500`}
                                            >
                                                {ad.status}
                                            </span>
                                        </div>
                                        <div className="flex items-center">
                                            <div className="text-sm text-gray-800 antialiased">
                                                <Moment format="ll">
                                                    {ad.start_date}
                                                </Moment>{' '}
                                                -{' '}
                                                <Moment format="ll">
                                                    {ad.end_date}
                                                </Moment>
                                            </div>
                                            <svg
                                                className="ml-2"
                                                viewBox="0 0 24 24"
                                                width="24"
                                                height="24"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                fill="none"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <polyline points="9 18 15 12 9 6"></polyline>
                                            </svg>
                                        </div>
                                    </Link>
                                ))}
                        </div>
                    </>
                )}
                {isLoadingPending && <div>Loading Pending Mobile Ads...</div>}
                {!isLoadingPending && (
                    <>
                        <div className="mt-12">
                            <div className="text-2xl font-thin">
                                Pending Ads
                            </div>
                        </div>
                        <div className="bg-white rounded shadow flex flex-col overflow-hidden">
                            {pendingAds.data &&
                                pendingAds.data.map((ad, index) => (
                                    <Link
                                        className={`p-4 hover:bg-blue-500 flex justify-between items-center hover:text-white`}
                                        to={`/dashboard/${site.value}/nativeads/${ad.id}`}
                                    >
                                        <div>
                                            {ad.title}{' '}
                                            <span
                                                className={`ml-2 text-xs text-black uppercase rounded-full px-2 py-1 bg-gray-300`}
                                            >
                                                {ad.status}
                                            </span>
                                        </div>
                                        <div className="flex items-center">
                                            <div className="text-sm text-gray-800 antialiased">
                                                <Moment format="ll">
                                                    {ad.start_date}
                                                </Moment>{' '}
                                                -{' '}
                                                <Moment format="ll">
                                                    {ad.end_date}
                                                </Moment>
                                            </div>
                                            <svg
                                                className="ml-2"
                                                viewBox="0 0 24 24"
                                                width="24"
                                                height="24"
                                                stroke="currentColor"
                                                strokeWidth="2"
                                                fill="none"
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                            >
                                                <polyline points="9 18 15 12 9 6"></polyline>
                                            </svg>
                                        </div>
                                    </Link>
                                ))}
                        </div>
                    </>
                )}
                <div className="flex mt-8 mb-24">
                    <Link
                        to={`/dashboard/${site.value}/nativeads/archived`}
                        className="mb-1 flex flex-row items-center border-2 border-orange-500 bg-orange-500 hover:bg-orange-600 hover:border-orange-600 text-white px-3 rounded cursor-pointer text-center py-1 shadow outline-none"
                    >
                        <span>
                            <svg
                                className="w-5 h-5 pr-1"
                                viewBox="0 0 24 24"
                                width="24"
                                height="24"
                                stroke="currentColor"
                                strokeWidth="2"
                                fill="none"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            >
                                <polyline points="21 8 21 21 3 21 3 8"></polyline>
                                <rect x="1" y="3" width="22" height="5"></rect>
                                <line x1="10" y1="12" x2="14" y2="12"></line>
                            </svg>
                        </span>
                        View Archived Ads
                    </Link>
                </div>
            </div>
        </Layout>
    )
}

export default NativeAds
